import React from "react";

export const Stats = ({ name, base, colorOutcome }) => {
  const style = {
    backgroundColor: colorOutcome ? colorOutcome : " rgb(255, 207, 215)",
    color: colorOutcome ? "white" : "purple",
  };
  const nameParts = name.split("-"); // Divide por guion
  const displayedName = nameParts
    .map((part) => part[0].toUpperCase()) // Toma la primera letra de cada palabra y la pone en mayúsculas
    .join(""); // Une las primeras letras

  return (
    <div>
      <div className="stat-item">
        <div style={style} className="circle-stat">
          {displayedName}
        </div>
        <p className="number">{base} </p>
      </div>
    </div>
  );
};

export default Stats;
